module.exports = __webpack_public_path__ + "static/media/camera.a1670ec4.svg";